import React from 'react';

import usePopularBreeds from 'dpl/homepage/hooks/usePopularBreeds';

import HomepageFooterSectionLinksSkeleton from './HomepageFooterSectionLinksSkeleton';

const SECTION_TITLE = 'Search our popular breeds';

export default function PopularBreedsFooterSection() {
  const { popularBreedsData, isFetching } = usePopularBreeds();

  if (isFetching) {
    return (
      <HomepageFooterSectionLinksSkeleton
        sectionTitle={SECTION_TITLE}
        linkCount={20}
      />
    );
  }

  return (
    <section className="PopularBreedsFooterSection container-xl">
      <h5 className="font-20 md:font-24 mb6 mb8-md lh-title">
        {SECTION_TITLE}
      </h5>
      <ul className="PopularBreedsFooterSection__listItems secondary font-14 md:font-18">
        {popularBreedsData.map(breed => (
          <li key={breed.name} className="mb2 truncate">
            <a className="footer-breed-link relative" href={breed.url}>
              {breed.name}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
